export const TAB_ITEMS = {
    IMAGES: "images",
    FLOORPLANS: "floorplans",
    OVERVIEW: "overview",
    DESCRIPTION: "description",
    FEATURES: "features",
    LOCATION: "location",
    ENERGY: "energy",
    PRICE: "price",
    PROVIDER: "propertyProvider",
};
